<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-show="false" v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :dateReadonly="false" />

    <!-- 종사자 정보 -->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 종사자 정보</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer mt-4">
        <div>
          <div>ID(사번)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <EmployeeSelector v-model="form.inputA_1" @select="onSelectEmployee" />
        </div>
        <div>
          <div>생년월일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <ml-input v-else v-model="form.inputA_2" readonly />
        </div>
        <div>
          <div>부서</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_3 }}</p>
          <ml-input v-else v-model="form.inputA_3" readonly />
        </div>
        <div>
          <div>성명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_7 }}</p>
          <ml-input v-else v-model="form.inputA_7" readonly />
        </div>
        <div>
          <div>현보직일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_9 }}</p>
          <ml-input v-else v-model="form.inputA_9" readonly />
        </div>
        <div>
          <div>연락처</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_10 }}</p>
          <ml-input v-else v-model="form.inputA_10" readonly />
        </div>
      </div>
    </div>

    <!-- 종사자 기본정보 -->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 종사자 기본정보</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer mt-4">
        <div>
          <div>질병력</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_1" />
        </div>
        <div>
          <div>진료병원/주기</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_2" />
        </div>
        <div>
          <div>가족력</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_3" />
        </div>
        <div>
          <div>음주</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_4" />
        </div>
        <div>
          <div>흡연</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_5" />
        </div>
        <div>
          <div>운동</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_6 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_6" />
        </div>
      </div>
    </div>

    <!-- 일반 검진-->
    <table361-general-checkup class="print-container mt-5" :list="form['일반검진']" @updateList="updateList1" :isPrint="isPrint" :isReadonly="board.readonly" />

    <!-- 건강상담-->
    <Health class="print-container mt-5" v-model="form['건강상담']" :isPrint="isPrint" :isReadonly="board.readonly" />

    <!-- 투약현황 -->
    <Inject class="print-container mt-5" v-model="form['투약현황']" :isPrint="isPrint" :isReadonly="board.readonly" />

    <!-- 배치전 검진-->
    <table361-general-checkup
      class="print-container mt-5"
      :list="form['배치전 검진']"
      @updateList="updateList3"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
      title="배치전 검진"
      determination-label="특수건강진단 건강관리구분 판정"
      :determination-options="determinationOptions['배치전 검진']"
    />

    <!-- 배치후 검진-->
    <table361-general-checkup
      class="print-container mt-5"
      :list="form['배치후 검진']"
      @updateList="updateList4"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
      title="배치후 검진"
      determination-label="특수건강진단 건강관리구분 판정"
      :determination-options="determinationOptions['배치후 검진']"
    />

    <!-- 특수검진-->
    <table361-general-checkup
      class="print-container mt-5"
      :list="form['특수검진']"
      @updateList="updateList5"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
      title="특수검진"
      determination-label="특수건강진단 건강관리구분 판정"
      :determination-options="determinationOptions['특수검진']"
    />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import EmployeeSelector from "@/components/selector/EmployeeSelector.vue";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import Table361GeneralCheckup from "@/components/Table361GeneralCheckup.vue";
import Table361HealthCounseling from "@/components/Table361HeathCounseling.vue";
import moment from "moment";
import Health from "./components/Health.vue";
import Inject from "./components/Inject.vue";

export default {
  components: {
    Table361HealthCounseling,
    Table361GeneralCheckup,
    DateSelector,
    CompanySelector,
    FieldSelectModule,
    FileUploadModule,
    EmployeeSelector,
    Health,
    Inject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inputA_0: "",
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputB_7: "",
        // inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",
        inputA_9: "",
        inputA_10: "",
        inputA_11: "",
        inputA_12: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        companyName: "",
        fileList: [],
        일반검진: [],
        건강상담: [{ id: 1, input_10: "보건관리자", input_21: {} }],
        투약현황: [],
        "배치전 검진": [],
        "배치후 검진": [],
        특수검진: [],
      },
      options: {
        구분: [
          "사무직",
          "현업 - 청소 등 유지관리",
          "현업 - 도로의 유지·보수 종사자",
          "현업 - 환경미화종사자",
          "현업 - 폐기물 수거처리",
          "현업 - 공원·녹지 유지관리",
          "현업 - 산림조사·보호",
          "현업 - 조리시설",
          "현업",
          "노동자",
          "청원경찰",
          "기타",
        ],
        직종: ["공무원", "공무직", " 임기제", "기간제", "기능직", "근로자", "공공근로", "노인 일자리", "장애인 일자리", "지역공동체", "자활", "기타"],
      },
      determinationOptions: {
        일반검진: ["C2", "D2"],
        "배치전 검진": ["A", "C1", "C2", "CN", "D1", "D2", "R"],
        "배치후 검진": ["A", "C1", "C2", "CN", "D1", "D2", "R"],
        특수검진: ["A", "C1", "C2", "CN", "D1", "D2", "R"],
      },
    };
  },
  async created() {
    const isUpdateMode = !!this.$route.params.postId;
    if (!isUpdateMode) {
      const project_id = this.$route.params.proj_id;
      await this.$store.dispatch("project/LOAD_FIELD_LIST", { projectId: project_id, type: "사업장(직접수행)", keyword: "부산광역시 강서구청" });
      const fieldListInfo = this.$store.state.project.fieldListInfo;
      
      if (!!fieldListInfo.data[0]) {
        const data = fieldListInfo.data[0];
        this.form.stdInfo.field_id = data.id;
        this.form.stdInfo.field_name = data.field_name;
        this.form.stdInfo.field_address = data.com_address;
      }
    }
  },
  methods: {
    onSelectEmployee(data) {
      if (!!data.retirement_date) {
        // 퇴사일자가 존재하는 경우
        const hireDate = moment(data.hire_date);
        const retirementDate = moment(data.retirement_date);
        this.form.inputA_11 = retirementDate.diff(hireDate, "days");
      } else {
        const now = moment();
        const hireDate = moment(data.hire_date);
        this.form.inputA_11 = now.diff(hireDate, "days");
      }

      this.form.inputA_0 = data.fields.length > 0 ? data.fields[0].field_name : "";
      this.form.inputA_2 = data.date_of_birth;
      this.form.inputA_3 = data.company.com_name;
      this.form.inputA_4 = data.job_category;
      //   this.form.inputA_5 = data.employment_type;
      this.form.inputB_7 = data.employment_type;
      this.form.inputA_6 = data.job_title;
      this.form.inputA_7 = data.full_name;
      this.form.inputA_8 = data.hire_date;
      this.form.inputA_9 = data.current_position_date;
      this.form.inputA_10 = data.contact_number;
    },
    targetCompany(value) {
      this.form.companyName = value.com_name;
    },
    updateList1(value) {
      this.form["일반검진"] = value;
    },
    updateList2(value) {
      this.form["건강상담"] = value;
    },
    updateList3(value) {
      this.form["배치전 검진"] = value;
    },
    updateList4(value) {
      this.form["배치후 검진"] = value;
    },
    updateList5(value) {
      this.form["특수검진"] = value;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
</style>
